import React, { useState } from "react";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";
import { ContentTable } from "./ContentTable";

export const TableThongKe = ({
  tongSoCamDo,
  tongSoTinChap,
  tongSoTraGop,
  tongTienCamDo,
  tongTienTinChap,
  tongTienVayHo,
  tongCamDoLaiDaThu,
  tongTinChapLaiDaThu,
  tongLaiHoLaiDaThu,
  tongCamDoLaiTrongThang,
  tongTinChapLaiTrongThang,
  tongLaiHoLaiTrongThang,
  TongTienBHTraGop,
  TongLaiBHTraGopDaThu,
  TongSoBHTraGop,
  TongLaiBHTraGopTrongThang,
  isBanHangTraGop,
}) => {
  return (
    <div className="table-home-new">
      <div className="row">
        <div className="col-12" style={{ padding: "0px" }}>
          <div className="card">
            <div className="card-content">
              <div className="card-body">
                <div
                  className="table-wrapper"
                  style={{
                    // border: "10px solid #f0f0f0",
                    borderRadius: "10px",
                    overflowX: "auto", // quan trọng
                    width: "100%",
                  }}
                >
                  <table className="table">
                    <thead style={{ background: "#E6F5F5" }}>
                      <tr
                        style={{
                          padding: "0 0 10px 0",
                          color: "#1e2a47",
                          fontWeight: 700,
                        }}
                      >
                        <th scope="col"></th>

                        <th className="text-right">
                          Số hợp đồng đang vay
                          <br />
                          <span className="color7-bold">
                            {tongSoCamDo + tongSoTinChap + tongSoTraGop}
                          </span>
                        </th>

                        <th className="text-right">
                          Tổng đang cho vay
                          <br />
                          <span className="color-xanh-bold">
                            {formatNumber(
                              tongTienCamDo + tongTienTinChap + tongTienVayHo
                            )}
                          </span>
                        </th>

                        <th className="text-right">
                          Tổng lãi đã thu
                          <br />
                          <span className="color-cam-bold">
                            {formatNumber(
                              tongCamDoLaiDaThu +
                                tongTinChapLaiDaThu +
                                tongLaiHoLaiDaThu +
                                TongLaiBHTraGopTrongThang
                            )}
                          </span>
                        </th>
                        <th className="text-right">
                          Lãi tháng{" "}
                          {new Date().getMonth() +
                            1 +
                            "/" +
                            new Date().getFullYear()}
                          <br />
                          <span className="color-do-bold">
                            {formatNumber(
                              tongCamDoLaiTrongThang +
                                tongTinChapLaiTrongThang +
                                tongLaiHoLaiTrongThang
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">
                          <span
                            className="img-home-new"
                            style={{ marginLeft: "5rem" }}
                          >
                            <img src="app-assets/images/icon-cam-do-v2.png"></img>
                          </span>
                          <span>Cầm đồ</span>
                        </th>
                        <td className="text-right">
                          <span className="color7-bold">{tongSoCamDo}</span>
                        </td>
                        <td className="text-right ">
                          <a href="/trang-chu/cam-do.aspx">
                            <span className="color-xanh-bold btn-link">
                              {" "}
                              {formatNumber(tongTienCamDo)}
                            </span>
                          </a>

                          <br />
                          <span className="color7">
                            {Math.round(
                              (100 * tongTienCamDo) /
                                (tongTienCamDo +
                                  tongTienTinChap +
                                  tongTienVayHo)
                            )}
                            %
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-cam-bold">
                            {formatNumber(tongCamDoLaiDaThu)}
                          </span>
                          <br />
                          <span className="color7">
                            {Math.round(
                              (100 * tongCamDoLaiDaThu) /
                                (tongCamDoLaiDaThu +
                                  tongTinChapLaiDaThu +
                                  tongLaiHoLaiDaThu)
                            )}
                            %
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-do-bold">
                            {formatNumber(tongCamDoLaiTrongThang)}
                          </span>
                          <br />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <span
                            className="img-home-new"
                            style={{ marginLeft: "5rem" }}
                          >
                            <img src="app-assets/images/icon-tin-chap-v2.png"></img>
                          </span>
                          <span>Tín chấp</span>
                        </th>
                        <td className="text-right">
                          <span className=" color7-bold">{tongSoTinChap}</span>
                        </td>
                        <td className="text-right ">
                          <a href="/trang-chu/tin-chap.aspx">
                            <span className="color-xanh-bold btn-link">
                              {" "}
                              {formatNumber(tongTienTinChap)}{" "}
                            </span>
                          </a>

                          <br />
                          <span className="color7">
                            {Math.round(
                              (100 * tongTienTinChap) /
                                (tongTienTinChap +
                                  tongTienCamDo +
                                  tongTienVayHo)
                            )}
                            %
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-cam-bold">
                            {formatNumber(tongTinChapLaiDaThu)}
                          </span>
                          <br />
                          <span className="color7">
                            {Math.round(
                              (100 * tongTinChapLaiDaThu) /
                                (tongTinChapLaiDaThu +
                                  tongCamDoLaiDaThu +
                                  tongLaiHoLaiDaThu)
                            )}
                            %
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-do-bold">
                            {formatNumber(tongTinChapLaiTrongThang)}
                          </span>
                          <br />
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <span
                            className="img-home-new"
                            style={{ marginLeft: "5rem" }}
                          >
                            <img src="app-assets/images/tra_gop_icon-02.png"></img>
                          </span>
                          <span>Trả góp</span>
                        </th>
                        <td className="text-right">
                          <span className="color7-bold">{tongSoTraGop}</span>
                        </td>
                        <td className="text-right ">
                          <a href="/trang-chu/tra-gop.aspx">
                            <span className="color-xanh-bold btn-link">
                              {formatNumber(tongTienVayHo)}
                            </span>
                          </a>
                          <br />
                          <span className="color7">
                            {Math.round(
                              (100 * tongTienVayHo) /
                                (tongTienVayHo +
                                  tongTienTinChap +
                                  tongTienCamDo)
                            )}
                            %
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-cam-bold">
                            {formatNumber(tongLaiHoLaiDaThu)}
                          </span>
                          <br />
                          <span className="color7">
                            {Math.round(
                              (100 * tongLaiHoLaiDaThu) /
                                (tongLaiHoLaiDaThu +
                                  tongTinChapLaiDaThu +
                                  tongCamDoLaiDaThu)
                            )}
                            %
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-do-bold">
                            {formatNumber(tongLaiHoLaiTrongThang)}
                          </span>
                          <br />
                        </td>
                      </tr>
                      {isBanHangTraGop && (
                        <tr>
                          <th>
                            <span
                              className="img-home-new"
                              style={{ marginLeft: "5rem" }}
                            >
                              <img src="app-assets/images/tra_gop_icon-02.png"></img>
                            </span>
                            <span>Bán hàng trả góp</span>
                          </th>
                          <td className="text-right">
                            <span className="color7-bold">
                              {TongSoBHTraGop}
                            </span>
                          </td>
                          <td className="text-right ">
                            <a href="/trang-chu/ban-hang-tra-gop.aspx">
                              <span className="color-xanh-bold btn-link">
                                {formatNumber(TongTienBHTraGop)}
                              </span>
                            </a>
                            <br />
                            <span className="color7">
                              {Math.round(
                                (100 * TongTienBHTraGop) /
                                  (tongTienVayHo +
                                    TongTienBHTraGop +
                                    tongTienTinChap +
                                    tongTienCamDo)
                              )}
                              %
                            </span>
                          </td>
                          <td className="text-right">
                            <span className="color-cam-bold">
                              {formatNumber(TongLaiBHTraGopDaThu)}
                            </span>
                            <br />
                            <span className="color7">
                              {Math.round(
                                (100 * TongLaiBHTraGopDaThu) /
                                  (tongLaiHoLaiDaThu +
                                    TongLaiBHTraGopDaThu +
                                    tongTinChapLaiDaThu +
                                    tongCamDoLaiDaThu)
                              )}
                              %
                            </span>
                          </td>
                          <td className="text-right">
                            <span className="color-do-bold">
                              {formatNumber(TongLaiBHTraGopTrongThang)}
                            </span>
                            <br />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
